(function ($, Promise) {

        // Setup the prototype inheritance
        extend(BaseGamePAC, PACGrandePaix);

        // Constructor
        function PACGrandePaix() {

            // this.defaultEasing = CustomEase.create("custom", "0.65, 0, 0.35, 1");
            // this.defaultEasing = CustomEase.create("custom", "0.33, 1, 0.68, 1");
            // this.defaultEasing = CustomEase.create("custom", "0, 0.55, 0.45, 1");
            this.defaultEasing = CustomEase.create("custom", "M0,0 C0,0 0.108,0.051 0.152,0.114 0.263,0.272 0.424,1 0.96,1 0.984,1 1,1 1,1");
            this.defaultEasingIn = CustomEase.create("custom", "0.3, 0.0, 0.9, 1");
            this.defaultEasingOut = CustomEase.create("custom", "0.1, 0.0, 0.7, 1");

            this.titleTimeline = false;
            this.currentTimeline = false;
            this.currentTitleMode = -1;
            this.locked = false;

            this.currentTitleTextMode = -1;
            this.currentPageGroupIndex = -1;
            this.impetusSideBar = false;
            this.illustrationsSwiper = false;
            this.$sidebarContent = false;
            this.$sidebarScrollableElement = false;
            this.interval = false;

            this.screensaver = false;

            this.pagePosition = {
                left: {
                    x: 635,
                    y: 28,
                },
                right: {
                    x: 1240,
                    y: 28,
                },
                center: {
                    x: 936,
                    y: 28,
                }
            }

            // Super constructor
            BaseGamePAC.call(this, "data/grande-paix.json");
        }


        // To be overriden in child games
        PACGrandePaix.prototype.buildDOM = function () {
            return new Promise($.proxy(function (resolve, reject) {

                this.$sidebarContent = $("#sidebar .inner")
                this.$sidebarScrollableElement = $("#sidebar #sidebar-content")
                this.screensaver = new PACGrandePaixScreenSaver();

                gsap.config({
                    force3D: false,
                });

                $("#pages-groups .hotspot").on(this.touchEvent, $.proxy(function (e) {
                    e.stopImmediatePropagation();
                    var hotspotId = $(e.currentTarget).attr("id");
                    var groupIndex = $(e.currentTarget).data("group-index");
                    var pageIndex = $(e.currentTarget).data("page-index");
                    var hotspotIndex = $(e.currentTarget).data("hotspot-index");
                    var hotspot = this.data.page_groups[groupIndex].pages[pageIndex].hotspots[hotspotIndex];
                    this.selectHotspot(hotspotId, hotspot);
                }, this));

                // Apply nice positionning for each reader hotspot
                $("#pages-groups .mode-reader").each($.proxy(function (i, elReader) {
                    $(["fr", "en"]).each($.proxy(function (i1, lang) {
                        $(elReader).find(".reader-text ." + lang).each($.proxy(function (i2, text) {
                            $(text).find(".hotspot-word").each($.proxy(function (k, hotspotWord) {
                                var pageGroupName = $(hotspotWord).parents(".page").data("page-group");
                                var pageIndex = $(hotspotWord).parents(".page").data("page-index");
                                var hotspotId = "hotspot-reader-" + pageGroupName + "-" + pageIndex + "-" + k + "-" + lang;
                                var $hotspotEl = $("#" + hotspotId);
                                var $hotspotWord = $(hotspotWord);

                                requestAnimationFrame(function () {
                                    var classes = $("body").attr("class");
                                    $("body").removeClass("i18n-en i18n-fr");
                                    $hotspotEl.css({
                                        left: $hotspotWord.offset().left - $hotspotWord.parents(".page").offset().left - 2,
                                        top: $hotspotWord.offset().top - $hotspotWord.parents(".page").offset().top - 5,
                                        width: $hotspotWord.width() + 3,
                                        height: $hotspotWord.height() + 8,
                                    });
                                    $("body").addClass(classes);
                                });
                            }, this));
                        }, this));
                    }, this));
                }, this));

                // Create illustration slider
                var illustrationsCount = 0;
                $(this.data.page_groups).each($.proxy(function (i, page_group) {
                    $(page_group.pages).each($.proxy(function (j, page) {
                        $(page.hotspots).each($.proxy(function (k, hotspot) {
                            if (hotspot.mode == "illustration") {
                                var $slide = $("<div class='swiper-slide'><div class='inner'><img draggable='false' /></div></div>");
                                $slide.find("img").attr("src", hotspot.image);
                                $slide.data("group-name", page_group.group_name);
                                $slide.data("group-index", i);
                                $slide.data("page-index", j);
                                $slide.data("hotspot-index", k);
                                $("#illustration-slider .swiper-wrapper").append($slide);
                                illustrationsCount++;
                            }
                        }, this));
                    }, this));
                }, this));

                this.illustrationsSwiper = new Swiper('#illustration-slider', {
                    speed: 700,
                    spaceBetween: 0,
                    threshold: 5,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    on: {
                        slideChange: $.proxy(this.onIllustrationSelect, this)
                    },
                });

                // Hide reader mode
                TweenMax.set($(".mode-reader"), {
                    autoAlpha: 0,
                });

                $(".page-grid").on(this.touchEvent, $.proxy(function (e) {
                    e.stopImmediatePropagation();
                    var $el = $(e.currentTarget);
                    this.gridSelectPage($el, $el.data("page-group"), $el.data("page-position"));
                }, this));

                $(".page-group").hammer({}).bind("swipe", $.proxy(function (e) {
                    if (this.locked == true) {
                        return;
                    }
                    if (e.gesture.direction == Hammer.DIRECTION_LEFT) {
                        this.selectNextPageGroup();
                    } else if (e.gesture.direction == Hammer.DIRECTION_RIGHT) {
                        this.selectPrevPageGroup();
                    }
                }, this));

                // Impetueus plugin used for main timeline
                this.impetusSideBar = new Impetus({
                    source: "#sidebar",
                    boundX: [0, 1],
                    boundY: [0, 1],
                    update: $.proxy(this.updateImpetusSidebarPosition, this)
                });
                this.impetusSideBar.pause();

                window.convertSVGToInline();

                $("#main").addClass("ready");

                resolve();

            }, this));
        }

        // To be overriden in child games
        PACGrandePaix.prototype.initGame = function () {
            console.log("init game");

            // Go to first screen
            this.initScreenSaver();
            this.goToScreen(1);

            // this.goToScreen(2);

            // this.goToScreen(3);
            // this.selectPageGroup("page01");
            // this.selectPageGroup("page02-03");
            // this.selectPageGroup("page04-05")
            // this.selectPageGroup("page06-07")
            // this.toggleReaderMode();
        };


        // Overriding goToScreen for some custom animations
        // PACGrandePaix.prototype.goToScreen = function (screenId, callback) {
        //
        // // Super constructor
        // if (BaseGamePAC.prototype.goToScreen.call(this, screenId, callback) == false) {
        // return false;
        // }
        //
        // if (this.currentScreen == 1 && screenId == 2) {
        //     this.placeTitle("small", "show");
        //     $(".page-grid .image-wrapper").show();
        // }
        // }

        // To be overriden in child games
        PACGrandePaix.prototype.initScreen = function (screenId) {

            // Super constructor
            if (BaseGamePAC.prototype.initScreen.call(this, screenId) == false) {
                return false;
            }

            switch (screenId) {
                case 1:
                    this.reset();
                    this.placeTitle("big", "hide");
                    this.screensaver.start();
                    this.toggleLanguageButton(false);
                    break;
                case 2:
                    this.placeTitle("small", "show");
                    this.screensaver.stop();
                    this.toggleLanguageButton(true);
                    $(".page-grid .image-wrapper").show();
                    break;
                case 3:
                    this.screensaver.stop();
                    this.placeTitle("small", "show");
                    break;
            }

        }

        PACGrandePaix.prototype.start = function (language) {

            // Super constructor
            if (BaseGamePAC.prototype.start.call(this) == false) {
                return;
            }

            console.log("starting in ", language)
        }

        PACGrandePaix.prototype.selectIntroLanguage = function (e) {

            var language = $(e.currentTarget).data("lang");
            this.i18n.setWithFlip(language);

            if (this.interval != false) {
                clearInterval(this.interval);
                this.interval = false;
            }
            this.interval = setTimeout($.proxy(function () {
                this.goToScreen(2);
            }, this), 100)


            this.placeTitle("small", "show");
            $(".page-grid .image-wrapper").show();
        }

        // PACGrandePaix.prototype.placeTitle = function (titleMode, textMode) {
        //     BaseGamePAC.prototype.placeTitle.call(this, titleMode, textMode);
        // }

        PACGrandePaix.prototype.gridSelectPage = function ($el, pageGroup, pagePosition) {

            // Create transition clone
            $("#page-clone").remove()
            var clone = $el.clone();
            clone.attr("id", "page-clone")
            clone.css({
                top: "",
                left: "",
                position: "absolute",
                zIndex: 10,
                overflow: "hidden"
            });
            clone.find(".page-label").remove();
            clone.find(".image-wrapper").css({
                overflow: "hidden"
            });
            $("#main").append(clone)

            // Update toolbar
            this.currentPageGroupIndex = $("#group-" + pageGroup).data("group-index");
            this.toolbarSelect(pageGroup);
            $("#pages-toolbar").addClass("disabled");

            // Update legends visibility
            var showLegend = (pageGroup == "page01" || pageGroup == "page02-03") ? 0 : 1;
            TweenMax.set($("#pages-legend"), {
                opacity: showLegend,
            });

            this.goToScreen(3);

            // Animate in
            var tl = new TimelineMax();
            tl.fromTo(clone, 0.65, {
                x: $el.offset().left,
                y: $el.offset().top,
            }, {
                x: this.pagePosition[pagePosition].x,
                y: this.pagePosition[pagePosition].y,
                // ease: this.defaultEasing,
                ease: Sine.easeInOut
            });

            tl.fromTo(clone.find(".image-wrapper"), 0.65, {
                height: 375,
            }, {
                height: 922,
                // ease: this.defaultEasing,
                ease: Sine.easeInOut
            }, "-=0.65");

            tl.fromTo(clone.find(".main-image"), 0.65, {
                scale: 0.455,
                transformOrigin: "left top"
            }, {
                scale: 1,
                // ease: this.defaultEasing,
                ease: Sine.easeInOut
            }, "-=0.65");

            tl.add($.proxy(function (pageGroup) {
                this.gridShowPageGroup(pageGroup, pagePosition);
                requestAnimationFrame(function () {
                    clone.remove()
                });
            }, this, pageGroup), "-=0", [pageGroup], this);

            tl.fromTo("#toggle-reader", 0.5, {
                opacity: 0,
                scale: 0.7,
            }, {
                opacity: 1,
                scale: 1,
                ease: Back.easeOut,
            }, "+=1.35");

            // Reposition toggle reader mode
            var mode = (pagePosition == "center") ? "single" : "double"
            tl.add($.proxy(function (mode) {
                this.repositionToggleModeButton(mode);
            }, this, mode), "", [], this);

            requestAnimationFrame(function () {
                $el.find(".image-wrapper").hide();
            });

        }

        PACGrandePaix.prototype.gridShowPageGroup = function (pageGroup, pagePosition) {
            var $groupEl = $("#group-" + pageGroup);
            var tl = new TimelineMax();

            // No animation (from grid)
            tl.set($groupEl, {
                opacity: 1,
                scale: 1,
                y: 0,
                x: 0,
            });
            $groupEl.addClass("active");

            // Reset zIndex
            $groupEl.find(".page").css("zIndex", '');

            if (pagePosition == "left") {
                $groupEl.find("[data-page-position='left']").css("zIndex", 1);
                tl.fromTo($groupEl.find("[data-page-position='right']"), 0.5, {
                    x: -500,
                    opacity: 0.7,
                }, {
                    x: 0,
                    opacity: 1,
                    ease: this.defaultEasingOut,
                });

            } else if (pagePosition == "right") {
                $groupEl.find("[data-page-position='right']").css("zIndex", 1);
                tl.fromTo($groupEl.find("[data-page-position='left']"), 0.5, {
                    x: 500,
                    opacity: 0.7,
                }, {
                    x: 0,
                    opacity: 1,
                    ease: this.defaultEasingOut,
                });
            }

            tl.fromTo($groupEl.find(".hotspot"), 0.45, {
                opacity: 0,
            }, {
                opacity: 1,
                ease: this.defaultEasingOut,
            });

            tl.add(function () {
                $("#pages-toolbar").removeClass("disabled");
            })
        }

        PACGrandePaix.prototype.backToGrid = function () {
            var tl = new TimelineMax();
            var $currentGroup = $(".page-group.active");

            this.closeHotspots(false);
            this.toolbarSelect("grid");
            $("#pages-toolbar").addClass("disabled");

            tl.to($("#toggle-reader"), 0.25, {
                scale: 0.7,
                opacity: 0,
                ease: this.defaultEasing,
            });

            tl.to($currentGroup, 0.4, {
                opacity: 0,
                scale: 0.9,
                x: "+=15",
                y: "+=50",
                ease: this.defaultEasing,
            }, "-=0.20");

            tl.add($.proxy(function () {
                this.goToScreen(2);
                this.closeReaderMode();
                $(".page-group.active").removeClass("active")
            }, this,), "+=0.0", [], this);
        }

        PACGrandePaix.prototype.selectPageGroup = function (pageGroup) {
            var $currentGroup = $(".page-group.active");
            var $selectedGroup = $(".page-group#group-" + pageGroup);
            var direction = ($selectedGroup.data("group-index") < $currentGroup.data("group-index"));

            if (this.currentPageGroupIndex == $selectedGroup.data("group-index")) {
                return;
            }

            this.currentPageGroupIndex = $selectedGroup.data("group-index");
            // this.placeTitle("small", "show");
            this.toolbarSelect(pageGroup)
            this.closeHotspots(false);

            $currentGroup.removeClass("active");
            $selectedGroup.addClass("active");

            // Reset group values
            var tl = new TimelineMax();
            tl.set($selectedGroup, {
                scale: 1,
                y: 0,
                x: 0,
            });

            // Animate
            tl.to($currentGroup, 0.35, {
                x: (direction) ? 50 : -50,
                opacity: 0,
                ease: this.defaultEasing,
            });

            tl.add($.proxy(function () {
                this.placeTitle("small", "show");
            }, this), "+=0.25", [], this);

            tl.fromTo($selectedGroup, 0.35, {
                x: (direction) ? -50 : 50,
                opacity: 0,
            }, {
                x: 0,
                opacity: 1,
                ease: this.defaultEasing,
            }, "-=0.25");

            // Toggle pages legends visibility
            var showLegend = (pageGroup == "page01" || pageGroup == "page02-03") ? 0 : 1;
            tl.to($("#pages-legend"), 0.30, {
                opacity: showLegend,
                ease: this.defaultEasing,
            }, "-=0.3");

            // Reposition toggle reader mode
            var mode = ($selectedGroup.find(".mode-normal .page").length == 1) ? "single" : "double"
            tl.add($.proxy(function (mode) {
                this.repositionToggleModeButton(mode);
            }, this, mode), "", [], this);
        }

        PACGrandePaix.prototype.selectPrevPageGroup = function () {
            var nextIndex = constrain(this.currentPageGroupIndex - 1, 0, this.data.page_groups.length - 1);
            var nextCode = this.data.page_groups[nextIndex].group_name;
            this.selectPageGroup(nextCode);
        }

        PACGrandePaix.prototype.selectNextPageGroup = function () {
            var nextIndex = constrain(this.currentPageGroupIndex + 1, 0, this.data.page_groups.length - 1);
            var nextCode = this.data.page_groups[nextIndex].group_name;
            this.selectPageGroup(nextCode);
        }

        PACGrandePaix.prototype.selectHotspot = function (hotspotId, hotspot) {

            if (this.locked == true) {
                return;
            }

            this.locked = true;

            this.closeHotspots(false);
            $(".page .hotspots").addClass("disabled");
            $(".page-group.active .hotspots .hotspot").removeClass("active")
            $(".page-group.active .hotspots #" + hotspotId).addClass("active")

            if (hotspot.mode == "word") {
                this.selectWordHotspot(hotspotId, hotspot);
            } else if (hotspot.mode == "illustration") {
                this.selectIllustrationHotspot(hotspotId, hotspot);
            } else {
                this.locked = false;
            }

            $(".page-group.active").off(this.touchEvent).on(this.touchEvent, $.proxy(function (e) {
                if (!this.locked) {
                    e.stopImmediatePropagation();
                    $(".page-group.active").off(this.touchEvent);
                    this.closeHotspots(true);
                }
            }, this));
        }

        PACGrandePaix.prototype.selectWordHotspot = function (hotspotId, hotspot) {

            var tl = new TimelineMax();

            tl.to($(".page-group.active .hotspots .hotspot:not(.active)"), 0.45, {
                opacity: 0,
                ease: this.defaultEasing,
            })

            // Show overlay
            tl.to($(".page-group.active .hotspots-overlay"), 0.45, {
                opacity: 1,
                ease: this.defaultEasing,
            }, 0);

            tl.add($.proxy(function () {
                this.locked = false;
            }, this), 0.75)

            // Show sidebar
            this.showSidebar(hotspotId, hotspot);

        }

        PACGrandePaix.prototype.selectIllustrationHotspot = function (hotspotId, hotspot) {

            var slideIndex = $("#" + hotspotId).data("illustration-slide-index")

            // Go to screen 4
            this.goToScreen(4)

            // Set active slide
            this.illustrationsSwiper.enable();
            this.illustrationsSwiper.slideTo(slideIndex, 0);

            // Animate in
            var tl = new TimelineMax();
            tl.fromTo($("#illustration-slider"), 0.45, {
                opacity: 0,
                scale: 0.9,
            }, {
                opacity: 1,
                scale: 1,
                ease: this.defaultEasing,
            }, 0.25);

            tl.add($.proxy(function () {
                this.locked = false;
            }, this), 0.75)

            // Show sidebar
            this.showSidebar(hotspotId, hotspot);

        }

        PACGrandePaix.prototype.onIllustrationSelect = function () {
            var activeSlideIndex = this.illustrationsSwiper.activeIndex;
            var pageGroupIndex = $(".swiper-slide", this.illustrationsSwiper.$el).eq(activeSlideIndex).data("group-index");
            var pageGroupName = $(".swiper-slide", this.illustrationsSwiper.$el).eq(activeSlideIndex).data("group-name");
            var pageIndex = $(".swiper-slide", this.illustrationsSwiper.$el).eq(activeSlideIndex).data("page-index");
            var hotspotIndex = $(".swiper-slide", this.illustrationsSwiper.$el).eq(activeSlideIndex).data("hotspot-index");
            var hotspotId = "hotspot-" + pageGroupName + "-" + pageIndex + "-" + hotspotIndex;
            var hotspot = this.data.page_groups[pageGroupIndex].pages[pageIndex].hotspots[hotspotIndex];

            // Animate sidebar out
            this.locked = true;
            this.killCurrentTimeline();
            this.currentTimeline = new TimelineMax();
            this.currentTimeline.to($("#sidebar"), 0.45, {
                opacity: 0,
                y: 100,
            }, 0);
            this.currentTimeline.add($.proxy(function () {
                this.locked = false;
            }, this), 0.5)

            // Show sidebar
            this.showSidebar(hotspotId, hotspot);
        }

        PACGrandePaix.prototype.closeHotspots = function (animate) {

            if (this.locked == true) {
                return;
            }

            this.locked = true;

            this.killCurrentTimeline();

            if (this.illustrationsSwiper) {

                console.log(this.illustrationsSwiper)
                this.illustrationsSwiper.disable();
            }

            $(".page .hotspots").removeClass("disabled");
            $(".page .hotspot").removeClass("active");

            var tl = new TimelineMax();
            if (animate == false) {
                tl.set($(".page .hotspots-overlay"), {opacity: 0});
                tl.set($(".page .hotspot"), {opacity: 1})
            } else {
                tl.to($(".page .hotspots-overlay"), 0.45, {opacity: 0, ease: this.defaultEasing});
                tl.to($(".page .hotspot"), 0.45, {opacity: 1, ease: this.defaultEasing})
            }

            // If we are currently in illustration mode
            if (animate && this.currentScreen == 4) {
                tl.to($("#illustration-slider"), 0.45, {
                    opacity: 0,
                    scale: 0.9,
                    ease: this.defaultEasing,
                }, 0);
                tl.add($.proxy(function () {
                    this.goToScreen(3);
                }, this,), "-=0.4", [], this);
            }

            tl.add($.proxy(function () {
                this.locked = false;
            }, this), 0.5)

            this.closeSidebar(animate);
        }

        PACGrandePaix.prototype.showSidebar = function (hotspotId, hotspot) {

            // Set content
            this.$sidebarContent.addClass("active");

            // todo hide title description
            this.placeTitle("small", "hide");

            // Animate sidebar in
            var tl = new TimelineMax();
            tl.fromTo($("#sidebar"), 0.45, {
                opacity: 0,
                y: 100,
                immediateRender: false,
            }, {
                opacity: 1,
                y: 0,
                ease: this.defaultEasing,
                immediateRender: false,
            }, 0.5);

            // Update content
            tl.add($.proxy(function () {

                // Reset scroll position
                this.$sidebarScrollableElement.css("transform", "translate3D(0, 0, 0)")

                // Title
                if (hotspot.title.fr != "") {
                    this.$sidebarContent.find("#sidebar-title .fr").html(hotspot.title.fr);
                    this.$sidebarContent.find("#sidebar-title .en").html(hotspot.title.en);
                    this.$sidebarContent.removeClass("no-title");
                } else {
                    this.$sidebarContent.find("#sidebar-title .fr").html("&nbsp;");
                    this.$sidebarContent.find("#sidebar-title .en").html("&nbsp;");
                    this.$sidebarContent.addClass("no-title");
                }

                // Text
                this.$sidebarContent.find("#sidebar-content .text-content .fr").html(hotspot.text.fr);
                this.$sidebarContent.find("#sidebar-content .text-content .en").html(hotspot.text.en);

                // Update alliance
                if (typeof hotspot.alliance == "undefined") {
                    this.$sidebarContent.find("#alliance-content").hide();
                } else {
                    this.$sidebarContent.find("#alliance-content").show();
                    this.$sidebarContent.find("#alliance-content .alliance-angleterre").toggle(hotspot.alliance == "angleterre")
                    this.$sidebarContent.find("#alliance-content .alliance-france").toggle(hotspot.alliance == "france")
                }

                // Images
                $("#sidebar-images > div").remove();
                $(hotspot.images).each($.proxy(function (i, image) {
                    var $imgEl = $("<div class='sidebar-image'><div class='sidebar-image-legend i18n fading-i18n'><div class='fr'>" + image.legend.fr + "</div><div class='en'>" + image.legend.en + "</div></div><img draggable='false'/></div>");
                    $imgEl.find("img").attr("src", image.image)
                    $("#sidebar-images").append($imgEl);
                }, this));

            }, this), 0.45, [], this);

            // Enable Impetus scrolling
            tl.add($.proxy(function () {
                if (this.$sidebarContent.height() > $("#sidebar").height()) {
                    this.impetusSideBar.paused = false;
                    this.impetusSideBar.setBoundY([-(this.$sidebarContent.height() - $("#sidebar").height()), 0]);
                    this.updateImpetusSidebarPosition(0, 0);
                    this.impetusSideBar.setMultiplier(1);
                    this.impetusSideBar.resume();
                }
            }, this,), "+=0", [], this);

        }

        PACGrandePaix.prototype.closeSidebar = function (animate) {

            if (!this.$sidebarContent.hasClass("active")) {
                return;
            }

            this.$sidebarContent.removeClass("active");

            // Stop imepetus
            this.impetusSideBar.paused = true;
            this.impetusSideBar.setMultiplier(0);
            this.impetusSideBar.setValues(0, 0);
            this.impetusSideBar.pause();

            // Animate out
            var tl = new TimelineMax();
            tl.to($("#sidebar"), 0.45, {
                opacity: 0,
                y: 100,
                ease: this.defaultEasing,
            });

            if (animate) {
                tl.add($.proxy(function () {
                    this.$sidebarContent.css("transform", "translate3D(0, 0px, 0)")
                    this.placeTitle("small", "show");
                }, this,), "+=0", [], this);
            }
        }

        PACGrandePaix.prototype.updateImpetusSidebarPosition = function (x, y) {
            if (this.impetusSideBar.paused == false) {
                this.$sidebarScrollableElement.css("transform", "translate3D(0, " + y + "px, 0)")
            }
        }

        PACGrandePaix.prototype.toggleReaderMode = function () {

            this.closeHotspots(true);

            $("#toggle-reader").toggleClass("active");

            if ($("#toggle-reader").hasClass("active")) {

                // To reader mode
                var tl = new TimelineMax();
                tl.to($(".mode-reader"), 0.45, {
                    autoAlpha: 1,
                    ease: this.defaultEasing,
                });

            } else {

                // To normal mode
                var tl = new TimelineMax();
                tl.to($(".mode-reader"), 0.45, {
                    autoAlpha: 0,
                    ease: this.defaultEasing,
                });
            }
        }

        PACGrandePaix.prototype.closeReaderMode = function () {
            if ($("#toggle-reader").hasClass("active")) {
                this.toggleReaderMode();
            }
        }

        PACGrandePaix.prototype.repositionToggleModeButton = function (mode) {
            var toggleHorizontalOffset = (mode == "single") ? -310 : 0;
            TweenMax.to($("#toggle-reader"), 0.75, {
                x: toggleHorizontalOffset,
                ease: this.defaultEasing,
            }, "-=0.5");
        }

        PACGrandePaix.prototype.toolbarSelect = function (pageGroup) {
            $("#pages-toolbar .pages").removeClass("active");
            $(".button-prev, .button-next", "#pages-toolbar").removeClass("disabled");

            if (pageGroup == "grid") {
                $("#pages-toolbar .button-grid").addClass("active");

            } else {
                $("#pages-toolbar .pages[data-action-arg='" + pageGroup + "']").addClass("active");
            }

            if (pageGroup == "page01") {
                $("#pages-toolbar .button-prev").addClass("disabled");
            } else if (pageGroup == "page06-07") {
                $("#pages-toolbar .button-next").addClass("disabled");
            }

            TweenMax.to($("#button-selected-marker"), 0.4, {
                width: $("#pages-toolbar .pages.active").outerWidth(),
                x: $("#pages-toolbar .pages.active").offset().left - $("#pages-toolbar").offset().left,
                ease: this.defaultEasing,
            });

        }

        PACGrandePaix.prototype.killCurrentTimeline = function () {
            if (this.currentTimeline != false) {
                this.currentTimeline.kill();
                this.currentTimeline = false;
            }
        }

        PACGrandePaix.prototype.reset = function (screenId) {

            this.currentPageGroupIndex = -1;

            $(".page .hotspots").removeClass("disabled");

            $(".page-group").css("opacity", 0)
            this.closeHotspots(false);
            this.closeReaderMode();

            if (this.redirectTimeout != false) {
                clearTimeout(this.redirectTimeout);
                this.redirectTimeout = false;
            }

            // Super
            if (BaseGamePAC.prototype.reset.call(this, screenId) == false) {
                return false;
            }

        }

        // Expose PACGrandePaix
        window.PACGrandePaix = PACGrandePaix;
    }
)
(jQuery, Promise);
